import { ReactNode, forwardRef } from 'react'
import cn from 'classnames'

import styles from './page-template-content-padding.module.scss'

/**
 *  Это контейнер, в который следует поместить весь контент внутри PageTemplateContent,
 *  если он анимируется (animate prop) с сохранением отступов. Этот компонент будет,
 *  в этом случае, отчечать за отступы, а в PageTemplateContent нужно добавить skipPadding.
 *  Иначе при сворачивании, останется пустое место по высоте равное размеру padding.
 */

type Props = {
  children: ReactNode
  className?: string
}

export const PageTemplateContentPadding = forwardRef<HTMLDivElement, Props>(
  ({ children, className }, ref) => {
    return (
      <div className={cn(styles.root, className)} ref={ref}>
        {children}
      </div>
    )
  },
)
